import React from "react";
import Seo from "@/components/Seo";
import PhotoBackdrop from "@/components/PhotoBackdrop";
import Breadcrumb from "@/components/Breadcrumb";
import CTABanner from "@/components/CTABanner";
import CaseStudyCard from "@/components/cards/CaseStudyCard";
import RelatedBlock from "@/components/RelatedBlock";
import ServiceCard from "@/components/cards/ServiceCard";
import { ALL_SERVICES } from "@/data/nav";

// Case studies known to exist. As new ones are published, add them here + a
// dedicated /case-studies/{slug} route.
const CASE_STUDIES = [
  {
    slug: "tangential-taping-machine",
    title: "Designing and building a bespoke tangential taping machine.",
    blurb:
      "Purpose-built cable-wrapping machine designed, fabricated, wired, PLC-programmed and commissioned end-to-end by Lutrom.",
    image: "/gallery/assembled-taping-unit.jpg",
    sector: "Manufacturing",
    service: "Bespoke Machinery",
    region: "North West",
  },
];

const CaseStudiesIndex = () => {
  const topServices = ["plc-programming", "control-panel-design-and-build", "eicr-and-fixed-wire-testing"]
    .map((s) => ALL_SERVICES.find((x) => x.slug === s))
    .filter(Boolean);

  return (
    <div data-testid="case-studies-index">
      <Seo
        title="Case Studies — Industrial Engineering Projects"
        description="Recent Lutrom Engineering case studies — bespoke machinery, control panel builds, PLC programming, machine refurbishment and industrial installations across the North West."
        path="/case-studies"
      />
      <section className="relative overflow-hidden">
        <PhotoBackdrop src="/gallery/spindle-assembly.jpg" position="center 45%" />
        <div className="max-w-7xl mx-auto px-5 lg:px-10 pt-20 lg:pt-28 pb-16 relative">
          <p className="eyebrow">Case studies</p>
          <h1
            className="font-display mt-6 text-white max-w-4xl"
            style={{ fontSize: "clamp(40px, 5.5vw, 76px)", lineHeight: 1 }}
            data-testid="case-studies-h1"
          >
            Real work, real sites, real outcomes.
          </h1>
          <p className="mt-6 max-w-2xl text-[16px] leading-relaxed text-[color:var(--lt-text-dim)]">
            A selection of recent Lutrom Engineering projects — from bespoke machinery
            builds to full plant refurbishment.
          </p>
        </div>
      </section>

      <Breadcrumb items={[{ label: "Case Studies" }]} />

      <section className="max-w-7xl mx-auto px-5 lg:px-10 mt-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {CASE_STUDIES.map((c) => (
            <CaseStudyCard key={c.slug} {...c} />
          ))}
        </div>
        <p className="mt-8 text-[13.5px] text-[color:var(--lt-text-mute)]">
          More case studies coming as new projects complete. If you have an NDA-safe
          project you&apos;d like published, get in touch.
        </p>
      </section>

      <CTABanner variant="standard" phoneLocation="case_studies_index_bottom" />

      <RelatedBlock
        title="Explore the services behind the work"
        groups={[
          {
            eyebrow: "Services",
            items: topServices.map((s) => (
              <ServiceCard key={s.slug} slug={s.slug} name={s.name} blurb={s.blurb} categoryName={s.categoryName} />
            )),
          },
        ]}
      />
    </div>
  );
};

export default CaseStudiesIndex;
